// extracted by mini-css-extract-plugin
export const excerpt = "card-module--excerpt--2H-d6";